<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-31 18:17:09
 * @Descripttion: 
 * @LastEditors: Haotian Zheng
 * @LastEditTime: 2023-08-03 17:31:23
-->
<!-- 页面弹窗 -->
<template>
    <div v-if="showDialog" class="dialog-box">
        <div @click.stop="dialogBgClick" class="dialog-bg"></div>
        <div class="pageDialogBox">
            <div class="closeBtn">
                <img @click="closeDialogClick" src="../assets/image/pageDialog/closeBtn.png" alt="" />
            </div>
            <div class="title" :style="{ 'text-align': titleAlign, 'padding-left': pl }">
                <img v-if="type === 'warn'" class="header-title-img" src="@/assets/image/pageDialog/warnImg.png" alt="" />
                <img v-if="type === 'delete'" class="header-title-img" src="@/assets/image/pageDialog/deleteImg.png" alt="" />
                <img v-if="type === 'success'" class="header-title-img" src="@/assets/image/pageDialog/successImg.png" alt="" />
                <p :style="{ margin: marginNone }">{{ title }}</p>
            </div>
            <slot></slot>
            <div class="footerBtnBox">
                <div v-if="!noCloseBtn" class="footerCloseBtn" @click.stop="closeDialog">{{ closeBtn }}</div>
                <div v-if="sureBtn !== ''" :style="{ width: btnWidth }" class="footerSureBtn" @click="makeSure">
                    {{ sureBtn }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    props: {
        pl: {
            type: String,
            default: '16px',
        },
        marginNone: {
            type: String,
            default: '15px 0 17px',
        },
        titleAlign: {
            type: String,
            default: 'center',
        },
        title: {
            type: String,
            default: '提示',
        },
        // 是否显示弹窗
        showDialog: {
            type: Boolean,
            default: false,
        },
        closeBtn: {
            type: String,
            default: '关闭',
        },
        btnWidth: {
            type: String,
            default: null,
        },
        noCloseBtn: {
            type: Boolean,
            default: false,
        },
        sureBtn: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'warn',
        },
        disableClickBg: {
            type: Boolean,
            default: false,
        },
        sureNotClose: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        // 弹窗背景
        dialogBgClick() {
            if (this.disableClickBg) {
                return
            }
            //this.$emit('closeBtn')
            //this.$emit('update:showDialog', false)
        },
        // 点击关闭按钮
        closeDialog() {
            this.$emit('closeBtn')
            this.$emit('setClick')// 产品页面点击去设置按钮回调
            this.$emit('update:showDialog', false)
        },
        // 点击×关闭
        closeDialogClick() {
            this.$emit('closeBtn')
            this.$emit('update:showDialog', false)
        },
        // 点击确认
        makeSure() {
            this.$emit('makeSure')
            if (this.sureNotClose) {
                return
            }
            this.$emit('update:showDialog', false)
        },
    },
}
</script>
<style scoped lang="scss">
.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;

    .dialog-bg {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
    }

    .pageDialogBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ffffff;

        width: 520px;
        // height: 312px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        overflow: hidden;

        .closeBtn {
            height: 22px;
            text-align: right;
            margin: 16px 16px 0 0;

            img {
                display: inline-block;
                width: 20px;
                height: 22px;
                cursor: pointer;
            }
        }

        .title {
            margin-top: 10px;
            text-align: center;
            padding-left: 16px;

            img {
                display: inline-block;
                width: 58px;
                height: 58px;
                margin: 0 auto;
            }

            p {
                margin: 15px 0 17px;
                height: 24px;
                font-size: 20px;
                font-weight: 600;
                color: #1a1a1a;
                line-height: 24px;
            }
        }

        .footerBtnBox {
            margin-top: 30px;
            height: 72px;
            background: #fafbfc;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            div + div {
                margin-left: 20px;
            }

            .footerCloseBtn {
                width: 88px;
                height: 32px;
                background: #f7f8fa;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #aaaaaa;
                font-size: 14px;
                font-weight: 400;
                color: #424242;
                line-height: 32px;
                cursor: pointer;
            }

            .footerSureBtn {
                width: 88px;
                height: 32px;
                background: #be1a21;
                border-radius: 2px 2px 2px 2px;
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                line-height: 32px;
                cursor: pointer;
            }
        }
    }
}

.dialog-container {
    padding: 0 56px;
    font-size: 14px;
    font-weight: 400;
    color: #767676;
    line-height: 24px;
    text-align: center;
}
</style>
